/**
 * Summary Action - WHAT Section
 *
 * Edit mode UI for sending workout summary.
 * This is a simple recurring automation that sends a summary of workouts.
 *
 * V2 Reference: v2/app/templates/components/client-reminder-summary.hbs
 *
 * Note: This action has no editable "what" section - it simply sends
 * a summary of all workouts within the configured time period.
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'src/components/Typography';

import { ActionWhatSectionProps } from '../automationActions';

/**
 * Summary WHAT Section - Edit mode
 *
 * This action has no configurable "what" - it sends workout summaries.
 */
export const SummaryWhatSection: FC<ActionWhatSectionProps> = ({
  automation,
}) => {
  const { t } = useTranslation();
  const interval = automation.delayInterval ?? 1;
  const type = automation.delayType || 'week';
  const typeLabel = t(`automations.timing.delayUnit.${type}${interval === 1 ? '' : '_plural'}`);
  const periodText = `${interval} ${typeLabel}`;

  return (
    <Typography color="text.secondary">
      {t('automations.summary.sendSummary', { period: periodText })}
    </Typography>
  );
};

/**
 * Summary What Summary Component
 */
export const SummaryWhatSummary: FC<{
  automation: ActionWhatSectionProps['automation'];
}> = ({ automation }) => {
  const { t } = useTranslation();
  const interval = automation.delayInterval ?? 1;
  const type = automation.delayType || 'week';
  const typeLabel = t(`automations.timing.delayUnit.${type}${interval === 1 ? '' : '_plural'}`);
  const periodText = `${interval} ${typeLabel}`;

  return <>{t('automations.summary.sendWorkoutSummaryForLast', { period: periodText })}</>;
};
